import React from 'react';
import { resolveTablerIconComponent } from '../../design-system/icons/tablerIconMap';

export const TAB_ICON_ACTIVE = '#7c3aed';
export const TAB_ICON_INACTIVE = '#bdbdbd';

const STROKE = 1.75;

/** Bottom tab / line icons — Tabler (ti-*) */
const TABLER_BY_NAME = {
  home: 'home',
  story: 'player-play',
  community: 'users',
  chat: 'message-circle',
  life: 'compass',
  compass: 'compass',
  search: 'search',
  user: 'user',
  star: 'star',
  bell: 'bell',
  pencil: 'pencil',
  gps: 'current-location',
};

/**
 * @param {object} p
 * @param {string} p.name
 * @param {boolean} [p.active]
 * @param {number} [p.size]
 * @param {string} [p.color]
 * @param {string} [p.className]
 */
export function TabLineIcon({ name, active = false, size = 24, color, className = '' }) {
  const strokeColor = color || (active ? TAB_ICON_ACTIVE : TAB_ICON_INACTIVE);
  const tablerId = TABLER_BY_NAME[name];
  if (tablerId) {
    const Icon = resolveTablerIconComponent(tablerId);
    if (Icon) {
      return (
        <Icon
          size={size}
          stroke={STROKE}
          color={strokeColor}
          className={className}
          aria-hidden
        />
      );
    }
  }
  return null;
}
